(function() {
  var mainHeader = document.querySelector("main-header");
  if (!mainHeader) return;

  var isPC = window.matchMedia("(min-width: 768px)");

  function updateShoppingGuideStyle() {
    var guideLink = document.querySelector('a[href="/pages/shopping_guide"]');
    if (guideLink) {
      if (!isPC.matches) {
        guideLink.style.removeProperty("background-color");
        guideLink.style.removeProperty("color");
        guideLink.style.removeProperty("transition");
        return;
      }
      
      // スティッキー（@sticky）の状態に関わらず、PCサイズ時は常にオレンジ背景を設定
      guideLink.style.setProperty("background-color", "#D4651E", "important");
      guideLink.style.setProperty("color", "#ffffff", "important");
      guideLink.style.setProperty("transition", "background-color 0.3s ease", "important");
    }
  }

  var observer = new MutationObserver(updateShoppingGuideStyle);
  observer.observe(mainHeader, { attributes: true, attributeFilter: ["class"] });

  if (typeof isPC.addEventListener === "function") {
    isPC.addEventListener("change", updateShoppingGuideStyle);
  } else {
    isPC.addListener(updateShoppingGuideStyle);
  }

  updateShoppingGuideStyle();
})();